export default __webpack_public_path__ + "static/media/priority_icon3.44f6e136.svg";